import React from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import "./App.css";
import routes from "./routers";
import { useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#1e3b6e",
      },
      secondary: {
        main: "#1e3b6e",
      },
    },
  });

  const content = useRoutes(routes);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <div>{content}</div>
      </ThemeProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
